import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Drawer from '../ReusableComponents/NewDesign/Layout/Drawer/Drawer';
import TopBar from '../ReusableComponents/NewDesign/Layout/TopBar/TopBar';
import InitiateApplication from './views/InitiateApplication/InitiateApplication';
import VendorApplication from './views/VendorApplication/VendorApplication';
import { Container, Main } from '../ReusableComponents/NewDesign/Layout/Layout';

function VendorApplicationInit({ currentUser, fetchVendors, vendors, logout }) {
  const steps = ['Initiate Application', 'Vendor Application'];
  const [activeStep, setActiveStep] = useState(0);
  const [displayedStep, setDisplayedStep] = useState(0);

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <InitiateApplication
            currentUser={currentUser}
            fetchVendors={fetchVendors}
            vendors={vendors}
            onSubmit={() => {
              setActiveStep(1);
              setDisplayedStep(1);
            }}
          />
        );
      case 1:
        return <VendorApplication />;
      default:
        return <div>Unknown Step</div>;
    }
  };

  return (
    <Container className="pt-4">
      <TopBar />
      <Drawer
        currentUser={currentUser}
        stepper={{ steps, activeStep, displayedStep, editMode: false }}
        onNavigationClick={(index) => {
          console.log(index, 'index');
          // todo: manage click on previous step
        }}
        logout={logout}
      />
      <Main>{renderStepContent(activeStep)}</Main>
    </Container>
  );
}

VendorApplicationInit.propTypes = {
  currentUser: PropTypes.shape({
    role: PropTypes.string,
  }).isRequired,
  vendors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      company_name: PropTypes.string,
      internal_id: PropTypes.string,
    }),
  ).isRequired,
  fetchVendors: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

export default VendorApplicationInit;
